<template>
  <base-button class="btn btn-txt grow" @click="SelectAssetOption">{{
    item.text
  }}</base-button>
</template>
<script>
import { venuesAPI } from '../../../../config';
import BaseButton from '../UI/BaseButton.vue';

export default {
  components: { BaseButton },
  props: ['item', 'id'],
  data() {
    return {
      nodata: null,
    };
  },
  created() {},
  methods: {
    SelectAssetOption() {
      //  console.log('this is the option', this.item);

      this.$emit('asset-selected', this.item);
    },

    loadEquipments() {
      let myHeaders = {
        //'Authorization': 'Bearer ' + this.token,
        'Content-Type': 'application/json',
      };

      let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        //body: facility,
      };

      fetch(venuesAPI, requestOptions)
        .then((response) => {
          return response.json();
        })
        .then((data) => {
          //    console.log('equipments: ');
          if (data.result.length > 0) {
            // make sure array not empty.
            this.equipments = data.result;
          } else {
            //    console.log('equipments, no data: ', data);
          }
        })
        .catch((error) => {
          console.log('error', error);
        });
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
  margin-right: 2rem;
  margin-bottom: 2.5rem;
}

input,
textarea {
  font: inherit;
  padding: 0.15rem;
  border: 1px solid #ccc;
}

input:focus,
textarea:focus {
  outline: none;
  border-color: #9cb161;
  background-color: #f7ebff;
}

ul {
  list-style-type: none;
  display: flex;
}

.btn {
  border: none;
  height: 5rem;
  border-radius: 0px;
  width: 50rem;
}

.btn-txt {
  font-weight: bold;
  /* display: block; */
  /* font-family: inherit; */
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.grow {
  -webkit-transition: height 500ms;
  -moz-transition: height 500ms;
  transition: height 500ms;
}
.btn:hover .grow {
  width: 20%;
}
.btn:hover .grow:hover {
  width: 40%;
}

@media (max-width: 768px) {
  .btn {
    font-size: 1rem;
    width: 100%;
    height: auto;
  }
}
</style>
